// extracted by mini-css-extract-plugin
export default {"gameListContainer":"PageScroll__gameListContainer--3Lf","gameBlockContainer":"PageScroll__gameBlockContainer--Ssv","bingoBlockContainer":"PageScroll__bingoBlockContainer--3I1"};